import { render, staticRenderFns } from "./Div.vue?vue&type=template&id=92cfaa4a&"
import script from "./Div.vue?vue&type=script&lang=js&"
export * from "./Div.vue?vue&type=script&lang=js&"
import style0 from "./Div.vue?vue&type=style&index=0&id=92cfaa4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports